import markUrl from "pm-brand/logo/mark.svg?url";
import darkMarkUrl from "pm-brand/logo/mark-dark.svg?url";

/**
 * The shared kit's path-based mark, served as hashed first-party assets.
 * @returns An ornamental mark; the parent link provides its accessible name.
 */
export function BrandMark() {
  return <span className="brand-mark" aria-hidden="true"><img className="brand-mark__light" src={markUrl} alt="" width="52" height="52" /><img className="brand-mark__dark" src={darkMarkUrl} alt="" width="52" height="52" /></span>;
}
